import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/app";
import store from "./store/index";

const Login = () => import("./views/Login.vue");
const SignUp = () => import("./views/SignUp.vue");
const Transactions = () => import("./views/Transactions.vue");
const Debug = () => import("./views/Debug.vue");
const Overview = () => import("./views/Overview.vue");
const Categories = () => import("./views/Categories.vue");
const Settings = () => import("./views/Settings.vue");

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/overview"
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/signup",
      name: "signup",
      component: SignUp
    },
    {
      path: "/overview",
      name: "Overview",
      component: Overview,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/transactions",
      name: "transactions",
      component: Transactions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/categories",
      name: "categories",
      component: Categories,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/debug",
      name: "debug",
      component: Debug,
      meta: {
        requiresAuth: true
      }
    }

    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // }
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // If accessing a page that you don have permission to
  if (requiresAuth && !currentUser) {
    next("login");
    return;
  } else if (currentUser && !store.getters["authentication/isAuthenticated"]) {
    store.dispatch("authentication/setAuthenticatedUser", currentUser);
  }

  // If logged in go to month if try accesing login/signup
  if (
    (to.name === "login" || to.name === "signup") &&
    store.getters["authentication/isAuthenticated"]
  ) {
    next("overview");
    return;
  }

  next();
});

export default router;
